import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { ValueObject } from '@digibricks/core';
export var TimeTakenSubmission = /*#__PURE__*/function (_ValueObject) {
  _inherits(TimeTakenSubmission, _ValueObject);

  var _super = _createSuper(TimeTakenSubmission);

  function TimeTakenSubmission() {
    _classCallCheck(this, TimeTakenSubmission);

    return _super.apply(this, arguments);
  }

  _createClass(TimeTakenSubmission, null, [{
    key: "calculateMinutes",
    value: function calculateMinutes(params) {
      var assignmentDuration = params.assignmentDuration,
          createdAt = params.createdAt,
          submitTime = params.submitTime;

      if (typeof assignmentDuration !== 'number' || !Number.isFinite(assignmentDuration) || assignmentDuration <= 0) {
        return 0;
      }

      var submitTimeInSeconds = TimeTakenSubmission.parseUnixToSeconds(submitTime);
      var createdAtInSeconds = TimeTakenSubmission.parseUnixToSeconds(createdAt);

      if (submitTimeInSeconds === null || createdAtInSeconds === null) {
        return 0;
      }

      var durationInSeconds = assignmentDuration * 60;
      var timeTakenInSeconds = Math.max(0, submitTimeInSeconds - createdAtInSeconds);
      return Math.round(Math.min(durationInSeconds, timeTakenInSeconds) / 60);
    }
  }, {
    key: "parseUnixToSeconds",
    value: function parseUnixToSeconds(timestamp) {
      if (timestamp === undefined || timestamp === null) {
        return null;
      }

      var rawValue = typeof timestamp === 'number' ? timestamp.toString() : timestamp.trim();

      if (rawValue === '') {
        return null;
      }

      var numericValue = Number(rawValue);

      if (!Number.isFinite(numericValue)) {
        return null;
      }

      var isSecondType = rawValue.length === 10 && /^\d+$/.test(rawValue);
      return isSecondType ? numericValue : numericValue / 1000;
    }
  }]);

  return TimeTakenSubmission;
}(ValueObject);